module.exports = __webpack_public_path__ + "static/img/abimg5.5ab0e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/abimg5.png
// module id = TCw6
// module chunks = 1